import { Form, Input, InputNumber, Radio } from 'antd'
import { useTerminalCards } from '@api/useTerminalCards'
import { Vertical } from '@gravitate-js/excalibrr'
import React, { useEffect, useState } from 'react'
import { FormLabels } from '@components/Admin/Location/Cards/components/CreateCard/FormLabels'
import { useSelectedTerminalContext } from '@components/Admin/Location/Cards/components/CreateCard/TerminalSelection/TerminalSelectionContext'
import show = Mocha.reporters.Base.cursor.show

export const CreateCardForm = ({ form, onClose }) => {
  const [showActivityThreshold, setShowActivityThreshold] = useState(false)
  const [neverExpires, setNeverExpires] = useState(false)
  const { selectedTerminals } = useSelectedTerminalContext()
  const { editTerminalAssignment } = useTerminalCards()
  const handleCreateCard = async (values) => {
    const payload = {
      ...values,
      terminal_ids: values.selected_terminals.map((terminal) => terminal.terminal_id),
    }
    delete payload.selected_terminals
    const results = await editTerminalAssignment.mutateAsync(payload)
    onClose(results)
  }

  const handleTriggerChange = (changedValues, allValues) => {
    if (changedValues.certification_trigger) {
      const value = changedValues.certification_trigger
      if (value === 'Never Expires') {
        setNeverExpires(true)
        form.setFieldsValue({
          days_valid: null,
          warning_threshold: null,
          activity_threshold: null,
          dispatch_impact: 'Informational (No Impact)',
        })
      } else {
        setNeverExpires(false)
      }

      if (value === 'Automatic - Activity Based') {
        form.setFieldsValue({
          activity_threshold: 1,
        })
        setShowActivityThreshold(true)
      } else {
        setShowActivityThreshold(false)
        form.setFieldsValue({ activity_threshold: null })
      }
    }
  }
  const checkValues = (values) => {
    let hasError = false
    if (values.certification_trigger !== 'Never Expires') {
      if (values.days_valid <= 0) {
        form.setFields([{ name: 'days_valid', errors: ['Days Valid must be more than 0'] }])
        hasError = true
      }
      if (values.warning_threshold <= 0) {
        form.setFields([{ name: 'warning_threshold', errors: ['Warning Threshold must be more than 0'] }])
        hasError = true
      }
      if (values.warning_threshold && values.days_valid && values.warning_threshold > values.days_valid) {
        form.setFields([
          { name: 'warning_threshold', errors: ['Warning Threshold must be less than Days Valid'] },
          { name: 'days_valid', errors: ['Days Valid must be more than Warning Threshold'] },
        ])
        hasError = true
      }
      if (values.activity_threshold <= 0 && values.certification_trigger === 'Automatic - Activity Based') {
        form.setFields([{ name: 'activity_threshold', errors: ['Activity Threshold must be more than 0'] }])
        hasError = true
      }
    }
    if (hasError) {
      return
    }
    return handleCreateCard(values)
  }

  useEffect(() => {
    form.setFieldsValue({ selected_terminals: selectedTerminals })
  }, [selectedTerminals])
  return (
    <Form form={form} layout='vertical' onFinish={checkValues} onValuesChange={handleTriggerChange} className={'p-0'}>
      <FormLabels title={'Card Name'} />
      <Form.Item name='name' rules={[{ required: true, message: 'Card Name is required' }]}>
        <Input showCount maxLength={60} placeholder={'Enter name'} />
      </Form.Item>
      <FormLabels title={'Activity'} />
      <Form.Item name='activity' rules={[{ required: true, message: 'Activity is required' }]}>
        <Radio.Group>
          <Vertical>
            <Radio value={'Loading'}>Loading</Radio>
            <Radio value={'Unloading'}>Unloading</Radio>
          </Vertical>
        </Radio.Group>
      </Form.Item>
      <FormLabels title={'Certification Trigger'} width={'550px'} />
      <Form.Item
        name='certification_trigger'
        rules={[{ required: true, message: 'Certification Trigger is required' }]}
      >
        <Radio.Group>
          <Vertical>
            <Radio value={'Automatic - Activity Based'}>Automatic - Activity Based</Radio>
            <Radio value={'Manual - Date Based'}>Manual - Date Based</Radio>
            <Radio value={'Never Expires'}>Never Expires</Radio>
          </Vertical>
        </Radio.Group>
      </Form.Item>

      <>
        <FormLabels title={'Activity Threshold'} />
        <Form.Item
          name={'activity_threshold'}
          rules={[{ required: showActivityThreshold, message: 'Activity Threshold is required' }]}
        >
          <InputNumber placeholder={''} disabled={!showActivityThreshold} />
        </Form.Item>
      </>

      <>
        <FormLabels title={'Days Valid'} />
        <Form.Item name={'days_valid'} rules={[{ required: !neverExpires, message: 'Days Valid is required' }]}>
          <InputNumber placeholder={!neverExpires ? 'Enter days' : ''} disabled={neverExpires} />
        </Form.Item>
        <FormLabels title={'Warning Threshold'} />
        <Form.Item
          name={'warning_threshold'}
          rules={[{ required: !neverExpires, message: 'Warning Threshold is required' }]}
        >
          <InputNumber placeholder={!neverExpires ? 'Enter days' : ''} disabled={neverExpires} />
        </Form.Item>
      </>

      <FormLabels title={'Dispatch Impact'} />
      <Form.Item name='dispatch_impact' rules={[{ required: true, message: 'Dispatch Impact is required' }]}>
        <Radio.Group>
          <Vertical>
            <Radio value={'Alert'} disabled={neverExpires}>
              Alert
            </Radio>
            <Radio value={'Block Dispatch'} disabled={neverExpires}>
              Block Dispatch
            </Radio>
            <Radio value={'Alert Manual, Block Optimizer'} disabled={neverExpires}>
              Alert Manual, Block Optimizer
            </Radio>
            <Radio value={'Informational (No Impact)'}>Informational (No Impact)</Radio>
          </Vertical>
        </Radio.Group>
      </Form.Item>
      <FormLabels title={'Carding Instructions (Optional)'} />
      <Form.Item name={'carding_instructions'} rules={[{ required: false }]}>
        <Input.TextArea placeholder={'Enter Carding Instructions'} maxLength={300} showCount />
      </Form.Item>
      <Form.Item
        name={'selected_terminals'}
        rules={[{ required: true, message: 'Select a terminal.' }]}
        style={{ height: '0px' }}
      ></Form.Item>
    </Form>
  )
}
